var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }